<div class="menu">

  <div class="ribbon" *ngIf="this.ribbonEnv">
    <span *ngIf="this.ribbonEnv">{{ ribbonEnv }}</span>
  </div>
  <div class="logo-container" [routerLink]="['home']">
    <img class="logo" src="../../../assets/images/pulpo_logo.JPG" alt="logo" />
    <div class="logo-title">Admin Pulpo</div>
  </div>
  <button [routerLink]="['users']" routerLinkActive="active" class="corners zoom">
    <span>Users</span>
    <span class="material-icons text-light"> people </span>
  </button>
  <button [routerLink]="['groupes']" routerLinkActive="active" class="corners zoom">
    <span>Groupes et Agences</span>
    <span class="material-icons text-light"> group </span>
  </button>
  <button [routerLink]="['reporting']" routerLinkActive="active" class="corners zoom">
    <span> Reporting </span>
    <span class="material-icons text-light"> list </span>
  </button>
  <button [routerLink]="['settings']" routerLinkActive="active" class="corners zoom">
    <span> Paramétrages</span>
    <span class="material-icons text-light"> extension </span>
  </button>
  <button [routerLink]="['flight-search']" routerLinkActive="active" class="corners zoom">
    <span>Vol sec</span>
    <span class="material-icons text-light">flight</span>
  </button>
  <button [routerLink]="['minio']" routerLinkActive="active" class="corners zoom">
    <span>MinIO</span>
    <span class="material-icons text-light">storage</span>
  </button>
</div>